// extracted by mini-css-extract-plugin
export var aggregationCell = "_2g-n";
export var aggregationRow = "_2g-m";
export var borderlessSpinnerContainer = "_2g-3";
export var cardLayout = "_2g-6";
export var cardLayoutNoFooter = "_2g-9";
export var cardLayoutPageControl = "_2g-8";
export var closeIcon = "_2g-f";
export var columnHeaderSurface = "_2g-b";
export var columnHeaderSurfaceDragOverlay = "_2g-v";
export var columnHeaderSurfaceResizing = "_2g-s";
export var contextMenuAnchor = "_2g-1";
export var draggableColumnHeader = "_2g-t";
export var draggableColumnHeaderOverlay = "_2g-u";
export var expandIcon = "_2g-g";
export var expanded = "_2g-h";
export var filterDropdown = "_2g-i";
export var filterDropdownDivider = "_2g-d";
export var filterDropdownHeader = "_2g-l";
export var filterDropdownItem = "_2g-k";
export var filterDropdownModal = "_2g-j _2g-i";
export var filterItem = "_2g-c";
export var normalCellWithAdjustableBorder = "_2g-e";
export var pinButtonContainer = "_2g-o";
export var pinIcon = "_2g-p";
export var pinIconActive = "_2g-q";
export var spinner = "_2g-0";
export var spinnerContainer = "_2g-2";
export var tableContainer = "_2g-4";
export var tableContentDraggingColumns = "_2g-a";
export var tableContentInner = "_2g-7";
export var tableContentWrapper = "_2g-5";
export var viewButtonContainer = "_2g-r";